
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Globals } from 'app/_globals';
import { AssetAvailabilityScheduleService } from 'app/_services/asset-availability-schedule.service';
import { NotificationService } from 'app/_services/notification.service';
import { SiteAssetsService } from 'app/_services/site-assets.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'availability-history',
  templateUrl: './availability-history.component.html'
})
export class AvailabilityHistoryComponent implements OnInit {
  private selectedSiteId: any;
  private selectedAssetId: any;
  public selectedAsset: any;

  private routeRole: any;

  public tabitems: any[] = [];

  public availabilityItems = [];
  public loaded = false;

  // date filters
  public toDate: Date;
  public fromDate: Date;

  // pagination
  public pageSizes: any = environment.pageSizes;
  public pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  constructor(
    public globals: Globals,
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    public notificationService: NotificationService,
    private assetService: SiteAssetsService,
    private assetAvailabilityScheduleService: AssetAvailabilityScheduleService,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedAssetId = params.assetId;
      this.selectedSiteId = params.id;
    });

    this.routeRole = globals.user.routeRole;

    this.tabitems = [
      { path: '/' + this.routeRole + '/sites/' + this.selectedSiteId + '/assets/' + this.selectedAssetId, title: 'Back to Asset', class: 'back-link' },
      { path: '/' + this.routeRole + '/sites/' + this.selectedSiteId + '/assets/' + this.selectedAssetId + '/availability', title: 'Schedule History' },
    ];
  }

  ngOnInit() {
    const today = new Date();
    this.toDate = new Date();
    this.fromDate = new Date();
    this.toDate.setMonth(today.getMonth() + 1);
    this.toDate.setDate(1);
    this.fromDate.setDate(1);

    this.assetService.getAssetById(this.selectedAssetId).subscribe((data: any) => {
      this.selectedAsset = data;
    });

    this.resetPagination();
  }

  // populate the table
  private getPaginatedAvailabilityItems() {
    const filter = [];
    if (this.fromDate) {
      filter.push({
        key: 'startTime',
        value: this.fromDate.toISOString(),
      });
    }
    if (this.toDate) {
      filter.push({
        key: 'endTime',
        value: this.toDate.toISOString(),
      });
    }

    this.assetAvailabilityScheduleService.getAllAvailabilityItems(this.selectedAssetId, this.pagination, filter).subscribe((data: any) => {
      this.availabilityItems = data.body;

      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
      this.loaded = true;
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Error finding the schedule history');
    });
  }

  public onFromDateChange(event) {
    if (event) {
      this.fromDate = event;
    }

    this.goToFirstPage();
    this.getPaginatedAvailabilityItems();
  }

  public onToDateChange(event) {
    if (event) {
      this.toDate = event;
    }

    this.goToFirstPage();
    this.getPaginatedAvailabilityItems();
  }

  private resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();
    this.getPaginatedAvailabilityItems();
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getPaginatedAvailabilityItems();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
}
